import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRefresh = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M13.522.1A12.118 12.118 0 0 0 2.366 4.724V2.519A1.184 1.184 0 1 0 0 2.52v5.418c0 .654.53 1.185 1.183 1.185h5.409a1.184 1.184 0 0 0 0-2.37H3.825a9.755 9.755 0 0 1 15.018-1.55 1.181 1.181 0 0 0 1.673-.008 1.186 1.186 0 0 0-.008-1.676A12.127 12.127 0 0 0 13.522.1Zm3.396 20.218a9.777 9.777 0 0 0 3.257-3.07h-2.767a1.184 1.184 0 0 1 0-2.37h5.41c.653 0 1.183.53 1.183 1.185v5.418a1.184 1.184 0 1 1-2.366 0v-2.205a12.118 12.118 0 0 1-18.142 1.205 1.186 1.186 0 0 1-.008-1.675 1.182 1.182 0 0 1 1.673-.009 9.762 9.762 0 0 0 11.76 1.52Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRefresh);
export default ForwardRef;
